import React from "react";
import images from "../../../ressources/images";
import ProgressBar from "../ProgressBar/ProgressBar";
import "./Header.scss";
import { useHistory, useRouteMatch } from "react-router-dom";

const Header = ({ modules, answers }) => {
  const match = useRouteMatch();
  const router = useHistory();

  const handleClose = () => {
    const id = match.params.id;
    router.replace("/formations/" + id);
  };

  return (
    <div className="header">
      <div className="close_quizz" onClick={handleClose}>
        <img src={images.closeCross} alt="" />
      </div>
      <ProgressBar modules={modules} answers={answers} />
    </div>
  );
};

export default Header;
